import {EntityService} from '../../../service/EntityService';

export class PermissionService extends EntityService {

  static entity = 'app/system-permission';

  static systemPermission(): Promise<any> {
    return this.axios.get(`${this.entity}/system`).then(res => res.data);
  }

  static updatePermission(name: string, payload: any): Promise<any> {
    return this.axios.put(`${this.entity}?name=${name}`, payload).then(res => res.data);
  }
}
